import dagre from '@dagrejs/dagre'
import { Position } from 'reactflow'

import type { Node, Edge, NodeTypes } from 'reactflow'

import AppSetupButtonEdge from '~/components/ReactFlow/AppSetup/ButtonEdge'
import AppSetupCard from '~/components/ReactFlow/AppSetup/Card'
import TodolistTaskCard from '~/components/ReactFlow/Todolist/Card'
import TodolistTemplateButtonEdge from '~/components/ReactFlow/TodolistTemplate/ButtonEdge'
import TodolistTemplateTaskCard from '~/components/ReactFlow/TodolistTemplate/Card'

export const authModes = ['mwm_auth']

export const nodeTypes: NodeTypes = {
  'app-setup-card': AppSetupCard,
  'todolist-task-card': TodolistTaskCard,
  'todolist-template-task-card': TodolistTemplateTaskCard,
}

export const edgeTypes = {
  'app-setup-button-edge': AppSetupButtonEdge,
  'todolist-template-button-edge': TodolistTemplateButtonEdge,
}

const dagreGraph = new dagre.graphlib.Graph().setDefaultEdgeLabel(() => ({}))

export const getLayoutedElements = (
  nodes: Node[],
  edges: Edge[],
  options = {
    direction: 'TB',
    nodeHeight: 300,
    nodeWidth: 325,
  }
): {
  edges: Edge[]
  nodes: Node[]
  options?: {
    direction?: 'LR' | 'TB'
    nodeHeight?: number
    nodeWidth?: number
  }
} => {
  const isHorizontal = options.direction === 'LR'

  dagreGraph.setGraph({ rankdir: options.direction })

  nodes.forEach((node) => dagreGraph.setNode(node.id, { height: options.nodeHeight, width: options.nodeWidth }))

  edges.forEach((edge) => dagreGraph.setEdge(edge.source, edge.target))

  dagre.layout(dagreGraph)

  const newNodes = nodes.map((node) => {
    const nodeWithPosition = dagreGraph.node(node.id)
    const newNode = {
      ...node,
      // We are shifting the dagre node position (anchor=center center) to the top left
      // so it matches the React Flow node anchor point (top left).
      position: {
        x: nodeWithPosition.x - options.nodeWidth / 2,
        y: nodeWithPosition.y - options.nodeHeight / 2,
      },

      sourcePosition: isHorizontal ? Position.Right : Position.Bottom,

      targetPosition: isHorizontal ? Position.Left : Position.Top,
    }

    return newNode
  })

  return { edges, nodes: newNodes }
}
